import { Component, OnInit, ViewContainerRef, Input, Output } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { VW_AUCTIONS, AUCTIONS } from '../models/auctions';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { VW_SERIES, SERIES } from '../models/series';
import * as Globals from '../globals';

@Component({
  selector: 'app-auction',
  templateUrl: './auction.component.html',
  styleUrls: ['./auction.component.css']
})
export class AuctionComponent implements OnInit {

  loading: boolean;
  userProfile: any;
  auction: AUCTIONS;
  auctions: VW_AUCTIONS[];
  series: VW_SERIES[];
  @Input() seriesData: SERIES;  
  aucId: number;
  aucName: string;
  seriesId: number;
  seriesName: string;
  ssId: number;
  parentSsId: number;
  parentSsName: string;
  saCode: string;
  cdAucType: string;
  srId: number;
  search: string = '';
  p: number = 1;
  tab: number = 1;
  auctype: any[];
  authMenu: any;
  titleReport: string = '';
  btid: number;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/auction/list/0') {
          this.tab = 1;
          this.router.navigate(['/auction/list/1']);
        }
      };
    });
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/auction/list/1']);
    }
    this.auctions = [];
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getAuctions();
      this.authMenu = Globals.getAuthMenu(101, this.userProfile);
    }
  }

  setSeriesData(event:SERIES){
    this.seriesData = event;    
  }

  goToReport(event: any) {
    this.titleReport = event.name;
    this.seriesId = event.id;
    this.btid = event.btid;
    this.tab = 5;
  }
  getAuctions() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/auctions?search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.auctions = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  backClick(val: number) {
    if (val == 5) {
      this.tab = 2;
    } else if (val == 6) {
      this.tab = 3;
    } else if (val == 4 && this.parentSsId > 0) {
      this.tab = 6;
    }
    else {
      this.tab = this.tab - 1;
    }

  }
  goToSeries(event: any) {
    this.seriesId = event.id;
    this.seriesName = event.name;
  }

  goToAp(event: any) {
    this.ssId = event.id;
    this.saCode = event.name;
    this.parentSsId = event.parentSsId;
  }

  goToSubApList(event: any) {
    this.ssId = event.id;
    this.saCode = event.name;
    this.parentSsId = event.parentSsId;
    this.parentSsName = event.name;
  }

  refreshParent(event: any) {
    if (event.mode == 0) {
      this.tab = 1;
    } else {
      this.aucId = event.aucId;
      this.aucName = event.aucName;
      this.cdAucType = event.cdAucType;
    }
    this.getAuctions();
  }

  refreshAuction(event: any) {
    if (event.mode == 0) {
      this.tab = 2;
    } else {
      this.seriesId = event.seriesId;
      this.seriesName = event.seriesName;
    }
  } 

  refreshSeries(event: any) {
    if (event.mode == 0) {
      this.tab = 3;
    } else {
      this.ssId = event.ssId;
      this.saCode = event.saCode;
    }
  }
  refreshSubAgentList(event: any) {
    if (event.mode == 0) {
      this.tab = 6;
    } else {
      this.ssId = event.ssId;
      this.saCode = event.saCode;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/auction/auction.component.ts